import React from 'react';
import { useNavigate, useOutletContext } from 'react-router-dom';

import { useMutation, useQueryClient } from '@tanstack/react-query';

import { updateService } from 'api/Service';

import { ia } from 'lib/helpers/utility';
import { useStepperContext } from 'lib/context/StepperContext/StepperContext';

import NewServiceModal from 'components/shared/NewServiceModal/NewServiceModal';

import { getServiceChanges } from '../lib/helpers';

const EditServiceModal = (props) => {
  const navigate = useNavigate();
  const { practice, practiceId } = useOutletContext() || {};
  const { isAdmin } = useStepperContext();
  const queryClient = useQueryClient();

  const { mutateAsync: updateServiceHandler, isLoading } = useMutation({
    mutationFn: (params) => updateService(navigate, params),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['services'] });
    }
  });

  const onSave = async (updatedService, payScheduleChanges) => {
    const changes = getServiceChanges(updatedService, props.item);
    if (Object.keys(changes).length > 0 || ia(payScheduleChanges)) {
      await updateServiceHandler({
        service_id: props.item.id,
        practice_id: Number(practiceId),
        ...(Object.keys(changes).length > 0 && { fields: changes }),
        ...(ia(payScheduleChanges) && { paySchedule: payScheduleChanges })
      });
    }
    props.handleClose();
  };

  return (
    <NewServiceModal
      service={props.item}
      isOpen={props.isOpen}
      isLoading={isLoading}
      onClose={props.handleClose}
      onSave={onSave}
      isAdminContext={isAdmin}
      practice={practice}
    />
  );
};

export default EditServiceModal;
